export default __webpack_public_path__ + "static/media/goal-emails.65d14fa3.svg";